export type Plan = "FREE" | "PRO" | "EXPORT";

export type DashboardStat = {
  label: string;
  value: string;
  delta: string;
  tone: "green" | "orange" | "neutral";
};

export const dashboardStats: DashboardStat[] = [
  { label: "Pengunjung", value: "3.284", delta: "+18,2%", tone: "green" },
  { label: "Klik WhatsApp", value: "486", delta: "+11,4%", tone: "green" },
  { label: "Pesanan", value: "128", delta: "+8,7%", tone: "orange" },
  { label: "Estimasi omzet", value: "Rp18,7 jt", delta: "+22,1%", tone: "green" },
];

export const products = [
  { id: "prd-1", name: "Kopi Arabika Gayo", price: 78000, status: "Aktif", stock: 42, mode: "Beli langsung" },
  { id: "prd-2", name: "Kopi Robusta Temanggung", price: 65000, status: "Aktif", stock: 31, mode: "Beli langsung" },
  { id: "prd-3", name: "Hampers Kopi Nusantara", price: 185000, status: "Draft", stock: 12, mode: "Beli langsung" },
  { id: "prd-4", name: "Green Bean Arabika", price: 92000, status: "Aktif", stock: 120, mode: "Permintaan penawaran" },
];

export const orders = [
  { code: "CSJW-2048", buyer: "Nadia Putri", total: 156000, payment: "Dibayar", order: "Diproses", time: "10 menit lalu" },
  { code: "CSJW-2047", buyer: "Rama Aditya", total: 78000, payment: "Diklaim", order: "Menunggu verifikasi", time: "32 menit lalu" },
  { code: "CSJW-2046", buyer: "Dewi Lestari", total: 263000, payment: "Dibayar", order: "Dikirim", time: "2 jam lalu" },
  { code: "CSJW-2045", buyer: "Bima Arya", total: 65000, payment: "Belum dibayar", order: "Menunggu pembayaran", time: "3 jam lalu" },
];

export const buyerOpportunities = [
  { buyer: "Kirana Foods Sdn. Bhd.", country: "Malaysia", need: "Roasted coffee", score: 92, status: "Baru" },
  { buyer: "Lion City Grocers", country: "Singapore", need: "Retail coffee", score: 86, status: "Tersimpan" },
  { buyer: "Pacific Ethnic Market", country: "Australia", need: "Private label", score: 79, status: "Dihubungi" },
];

export const builderSections = [
  { id: "navbar", label: "Navbar", enabled: true },
  { id: "hero", label: "Hero", enabled: true },
  { id: "about", label: "Tentang usaha", enabled: true },
  { id: "products", label: "Produk", enabled: true },
  { id: "benefits", label: "Keunggulan", enabled: true },
  { id: "gallery", label: "Galeri", enabled: false },
  { id: "testimonials", label: "Testimoni", enabled: true },
  { id: "faq", label: "FAQ", enabled: true },
  { id: "contact", label: "Kontak", enabled: true },
  { id: "footer", label: "Footer", enabled: true },
];
